const newTopMarkets = {
  ATL: {
    img: 'https://s1.pclncdn.com/design-assets/new-top-markets/atlanta.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/atlanta.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/atlanta.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Skyline of Atlanta city at sunset in Georgia, USA',
  },
  CHI: {
    img: 'https://s1.pclncdn.com/design-assets/new-top-markets/chicago.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/chicago.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/chicago.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Chicago at dawn. Cityscape image of Chicago downtown at sunrise',
  },
  DFW: {
    img: 'https://s1.pclncdn.com/design-assets/new-top-markets/dallas.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/dallas.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/dallas.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Dallas, Texas cityscape with blue sky at sunset, Texas',
  },
  FLL: {
    img:
      'https://s1.pclncdn.com/design-assets/new-top-markets/fortlauderdale.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/fortlauderdale.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/fortlauderdale.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Fort Lauderdale, Florida, USA at the beach',
  },
  HNL: {
    img: 'https://s1.pclncdn.com/design-assets/new-top-markets/honolulu.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/honolulu.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/honolulu.jpg?opto&height=157&dpr=2&crop=16:9',
    alt:
      'Waikiki Beach and Diamond Head Crater including the hotels and buildings in Waikiki, Honolulu, Oahu island, Hawaii',
  },
  LAX: {
    img: 'https://s1.pclncdn.com/design-assets/new-top-markets/losangeles.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/losangeles.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/losangeles.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Sunset over Los Angeles, CA downtown',
  },
  NYC: {
    img: 'https://s1.pclncdn.com/design-assets/new-top-markets/newyorkcity.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/newyorkcity.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/newyorkcity.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Aerial view of Manhattan skyline at sunset, New York City',
  },
  PHX: {
    img: 'https://s1.pclncdn.com/design-assets/new-top-markets/pheonix.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/pheonix.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/pheonix.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Phoenix, Arizona, USA cityscape in downtown in the afternoon',
  },
  SEA: {
    img: 'https://s1.pclncdn.com/design-assets/new-top-markets/seattle.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/new-top-markets/seattle.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/new-top-markets/seattle.jpg?opto&height=157&dpr=2&crop=16:9',
    alt:
      'Seattle skyline panorama at sunset as seen from Kerry Park, Seattle, WA',
  },
}

const topMarkets = {
  LAS: {
    img: 'https://s1.pclncdn.com/design-assets/top-markets/lasvegas.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/top-markets/lasvegas.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/top-markets/lasvegas.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Las Vegas, Nevada, USA cityscape along the strip at twilight',
  },
  CUN: {
    img: 'https://s1.pclncdn.com/design-assets/top-markets/cancun.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/top-markets/cancun.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/top-markets/cancun.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Palm tree sandy beach sunrise',
  },
  ORL: {
    img: 'https://s1.pclncdn.com/design-assets/top-markets/orlando.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/top-markets/orlando.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/top-markets/orlando.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Orlando. Located in Lake Eola Park, Orlando, Florida, USA',
  },
  MIA: {
    img: 'https://s1.pclncdn.com/design-assets/top-markets/miami.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/top-markets/miami.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/top-markets/miami.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Clearwater beach with beautiful white sand in Florida USA',
  },
  PUJ: {
    img: 'https://s1.pclncdn.com/design-assets/top-markets/puntacana.jpg',
    imgSm:
      'https://s1.pclncdn.com/design-assets/top-markets/puntacana.jpg?opto&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/top-markets/puntacana.jpg?opto&height=157&dpr=2&crop=16:9',
    alt: 'Tropical beach resort at sunrise in Punta Cana, Dominican Republic',
  },
}

export const genericPromo = {
  GEN: {
    img:
      'https://s1.pclncdn.com/design-assets/top-markets/couple-traveling-cliff-edge-norway.jpg?opto&auto=webp',
    imgSm:
      'https://s1.pclncdn.com/design-assets/top-markets/couple-traveling-cliff-edge-norway.jpg?opto&auto=webp&height=157&dpr=2&crop=1:1',
    imgLg:
      'https://s1.pclncdn.com/design-assets/top-markets/couple-traveling-cliff-edge-norway.jpg?opto&auto=webp&height=157&dpr=2&crop=16:9',
    alt: 'Couple traveling cliff edge norway',
  },
}

export function getTopMarketImgObj(destAirport) {
  return { ...topMarkets, ...newTopMarkets, ...genericPromo }[destAirport]
}

export function isTopMarket(destAirport) {
  return !!topMarkets[destAirport]
}

export function isNewTopMarket(destAirport) {
  return !!newTopMarkets[destAirport]
}
